import Home from "pages/Home/Home";

export const HomeRoute = {
  id: "home",
  order: 0,
  exact: true,
  to: "/",
  title: "Dashboard",
  navbarTitle: "Dashboard",
  icon: "",
  component: Home,
};

export const ChangePasswordRoute = (hostKey, token, isPCTuser) => {
  return isPCTuser
    ? "/forgotPassword?isPCTuser=true"
    : "/changePassword?hostname=" + hostKey + "&token=" + token;
};

const RouteConsts = [HomeRoute];
export default RouteConsts;
